export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.11.4-1317.06",
  commitId: "c510e64984870d6fc83485dd61e638b41d3e26f1",
  commitTime: "2026-11-04T13:17:06.000Z",
});
